import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, union_type, bool_type, lambda_type, unit_type, class_type, list_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { cons, append, ofArray, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { stackClasses, classNames, logi } from "../../Utils.js";
import * as react from "react";
import { IsValid } from "./Common.js";
import { uncurry, comparePrimitives, max, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import "../../../src/Components/StatefulFormFields/Common.scss";


export class TextProps$1 extends Record {
    constructor(Value, Type, Classes, OnChange, Disabled, LabelText, Id, ValidationFn, DynamicWidth, HTMLProps, OnBlur, OnFocus, AutoComplete, Name) {
        super();
        this.Value = Value;
        this.Type = Type;
        this.Classes = Classes;
        this.OnChange = OnChange;
        this.Disabled = Disabled;
        this.LabelText = LabelText;
        this.Id = Id;
        this.ValidationFn = ValidationFn;
        this.DynamicWidth = DynamicWidth;
        this.HTMLProps = HTMLProps;
        this.OnBlur = OnBlur;
        this.OnFocus = OnFocus;
        this.AutoComplete = AutoComplete;
        this.Name = Name;
    }
}

export function TextProps$1$reflection(gen0) {
    return record_type("Components.StatefulFormFields.Text.TextProps`1", [gen0], TextProps$1, () => [["Value", string_type], ["Type", string_type], ["Classes", list_type(string_type)], ["OnChange", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)], ["Disabled", bool_type], ["LabelText", string_type], ["Id", string_type], ["ValidationFn", option_type(lambda_type(string_type, union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, string_type], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", string_type]]])))], ["DynamicWidth", bool_type], ["HTMLProps", list_type(class_type("Fable.React.Props.IHTMLProp"))], ["OnBlur", lambda_type(class_type("Browser.Types.FocusEvent", void 0, FocusEvent), unit_type)], ["OnFocus", lambda_type(class_type("Browser.Types.FocusEvent", void 0, FocusEvent), unit_type)], ["AutoComplete", string_type], ["Name", string_type]]);
}

export function TextProps$1_GetDefault() {
    return new TextProps$1("", "text", empty(), (_arg) => {
        logi("Text OnChange event fired, needs override.");
    }, false, "", "", void 0, false, empty(), (value_1) => {
    }, (value_2) => {
    }, "on", "");
}

function render$0027(props) {
    let isValid_1, inputClasses, props_1;
    const isBlurredState = react.useState(false);
    let isValid;
    const matchValue = [props.ValidationFn, isBlurredState[0]];
    let pattern_matching_result, validationFn;
    if (matchValue[0] != null) {
        if (matchValue[1]) {
            pattern_matching_result = 0;
            validationFn = matchValue[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const _arg = validationFn(props.Value);
            isValid = ((_arg.tag === 1) ? (new IsValid(2, _arg.fields[0])) : (new IsValid(1)));
            break;
        }
        case 1: {
            isValid = (new IsValid(0));
            break;
        }
    }
    const errorMessageHtml = (isValid.tag === 0) ? react.createElement(react.Fragment, {}) : ((isValid.tag === 2) ? react.createElement("div", {
        className: "input__validation-error",
    }, isValid.fields[0]) : react.createElement(react.Fragment, {}));
    const labelHtml = (props.LabelText === "") ? react.createElement(react.Fragment, {}) : react.createElement("span", {
        className: "input__text-label",
    }, props.LabelText);
    const containerClasses = classNames(ofArray([["input-container", true], ["input-container--disabled", props.Disabled]]));
    const children_6 = [(isValid_1 = isValid, (inputClasses = classNames(ofArray([["input__text", true], ["input__text--valid", equals(isValid_1, new IsValid(1))], ["input__text--invalid", isValid_1.tag === 2]])), (props_1 = append(append(toList(delay(() => append_1((props.Id !== "") ? singleton(new HTMLAttr(99, props.Id)) : empty_1(), delay(() => append_1((props.Name !== "") ? singleton(new HTMLAttr(123, props.Name)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(159, props.Type)), delay(() => append_1(singleton(new HTMLAttr(65, stackClasses(cons(inputClasses, props.Classes)))), delay(() => append_1(singleton(new HTMLAttr(134, true)), delay(() => append_1(singleton(new HTMLAttr(79, props.Disabled)), delay(() => append_1(singleton(new DOMAttr(7, props.OnFocus)), delay(() => append_1(singleton(new HTMLAttr(54, props.AutoComplete)), delay(() => singleton(new DOMAttr(8, (e_1) => {
        const value = props.OnBlur(e_1);
        isBlurredState[1](true);
        props.OnBlur(e_1);
    })))))))))))))))))))), props.HTMLProps), toList(delay(() => append_1(singleton(new HTMLAttr(161, props.Value)), delay(() => {
        let onChange;
        return append_1(singleton(new DOMAttr(9, (onChange = props.OnChange, (event) => {
            if (props.Type === "text") {
                const target = event.target;
                const prevBeginPos = target.selectionStart | 0;
                const prevEndPos = target.selectionEnd | 0;
                onChange(event);
                window.requestAnimationFrame((_arg_1) => {
                    target.selectionStart = (prevBeginPos | 0);
                    target.selectionEnd = (prevEndPos | 0);
                });
            }
            else {
                onChange(event);
            }
        }))), delay(() => {
            let css, valueLength, arg, length;
            return props.DynamicWidth ? singleton((css = ofArray([new CSSProp(395, (valueLength = (props.Value.length | 0), (arg = ((length = max(comparePrimitives, 10, max(comparePrimitives, props.LabelText.length, valueLength)), length - (length * 0.1))), toText(printf("%frem"))(arg)))), new CSSProp(253, "100%"), new CSSProp(249, "20rem")]), ["style", keyValueList(css, 1)])) : empty_1();
        }));
    }))))), react.createElement("input", keyValueList(props_1, 1))))), labelHtml, errorMessageHtml];
    return react.createElement("div", {
        className: containerClasses,
    }, ...children_6);
}

export function render() {
    return FunctionComponent_Of_Z5A158BBF(render$0027, void 0, uncurry(2, void 0), void 0, "render", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\StatefulFormFields\\Text.fs", 146);
}

